import NextMonthDelta from './NextMonthDelta';
import NextMonthExpense from './NextMonthExpense';
import NextMonthImageDelta from './NextMonthImageDelta';
import NextMonthIncome from './NextMonthIncome';

const Widgets = {
    "NextMonthIncome": NextMonthIncome,
    "NextMonthExpense": NextMonthExpense,
    "NextMonthDelta": NextMonthDelta,
    "NextMonthImageDelta": NextMonthImageDelta
} as const;

export default Widgets;